import { render } from "./Footer.vue?vue&type=template&id=04a30915&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=04a30915&scoped=true&lang=css"
import "./Footer.vue?vue&type=style&index=1&id=04a30915&lang=css"

import exportComponent from "/builds/off-group-apps/personal-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a30915"]])

export default __exports__